import * as React from "react";
import type { SVGProps } from "react";
const SvgIcDashboard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <rect
      width={18}
      height={7}
      x={3}
      y={3}
      stroke="#040747"
      strokeWidth={1.5}
      rx={1}
    />
    <rect
      width={7.5}
      height={7}
      x={3}
      y={13}
      stroke="#040747"
      strokeWidth={1.5}
      rx={1}
    />
    <rect
      width={7.5}
      height={7}
      x={13.5}
      y={13}
      stroke="#040747"
      strokeWidth={1.5}
      rx={1}
    />
  </svg>
);
export default SvgIcDashboard;
